<template>
  <v-dialog persistent v-model="dialog" :max-width="options.width" @keydown.esc="cancel" v-bind:style="{ zIndex: options.zIndex }">
    <v-card>
      <v-toolbar dark :color="options.color" dense text>
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout row justify-start>
          <v-flex class="item" xs12 sm12> 
            <v-text-field v-model.trim="dsOcorrencia"
              label="Ocorrência" outline clearable>
            </v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn id="confirmar" round color="primary" @click.native="confirm">Confirmar</v-btn>
        <v-btn id="cancel" round color="grey" dark @click.native="cancel">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      resolve: null,
      reject: null,
      title: null,
      dsOcorrencia: '',
      options: {
        color: 'primary',
        width: 350,
        zIndex: 200
      }
    }),
    methods: {
      open(title, options) {
        this.dialog = true
        this.title = title
        this.options = Object.assign(this.options, options)
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      },
      confirm() {
        this.resolve(this.dsOcorrencia)
        this.dialog = false
      },
      cancel() {
        this.resolve('')
        this.dialog = false
      }
    }
  }
</script>